var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurnOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2H6C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V9C12.75 9.41421 12.4142 9.75 12 9.75C11.5858 9.75 11.25 9.41421 11.25 9V7C11.25 6.58579 11.5858 6.25 12 6.25ZM9.45043 8.59935C9.78162 8.35058 9.84844 7.88044 9.59968 7.54924C9.35091 7.21805 8.88076 7.15124 8.54957 7.4C7.15464 8.44777 6.25 10.1184 6.25 12C6.25 15.1757 8.82436 17.75 12 17.75C15.1756 17.75 17.75 15.1757 17.75 12C17.75 10.1184 16.8454 8.44777 15.4504 7.4C15.1192 7.15124 14.6491 7.21805 14.4003 7.54924C14.1516 7.88044 14.2184 8.35058 14.5496 8.59935C15.5835 9.376 16.25 10.6101 16.25 12C16.25 14.3473 14.3472 16.25 12 16.25C9.65279 16.25 7.75 14.3473 7.75 12C7.75 10.6101 8.41646 9.376 9.45043 8.59935Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnOff);
export default __webpack_public_path__ + "static/media/turnOff.fb0df7d71a566ec22b3ea315b72f475d.svg";
export { ForwardRef as ReactComponent };